import { ref } from "vue";
import { defineStore } from "pinia";

type MicrosoftConnectValue = boolean | Record<string, unknown> | null;

export const useMicrosoftConnectStore = defineStore("microsoftConnect", () => {
  const isConnectMicrosoft = ref<MicrosoftConnectValue>(null);

  const connectToMicroSoft = (val: MicrosoftConnectValue): void => {
    isConnectMicrosoft.value = val;
  };

  const clearConnections = (): void => {
    isConnectMicrosoft.value = null;
  };

  return {
    isConnectMicrosoft,
    connectToMicroSoft,
    clearConnections,
  };
});
